import MapLayer from '../map-layer.enum';
import setIncidentsLayer from './incident-layer';

function addIncidentsLayer(metadata?: {}) {
  return setIncidentsLayer(MapLayer.INCIDENTS, metadata);
}

export default addIncidentsLayer;
